//--------------------------------------------
//
// Collection of People used for notifications
//
//--------------------------------------------

export default [
	{
		name: {
			first: 'Anna',
			last: 'Hansen'
		},

		picture: {
			thumbnail: 'img/icons/icon1-f.jpg'
		}
	},

	{
		name: {
			first: 'Clifford',
			last: 'Harris'
		},

		picture: {
			thumbnail: 'img/icons/icon1-m.jpg'
		}
	},

	{
		name: {
			first: 'Nathaniel',
			last: 'Joiner'
		},

		picture: {
			thumbnail: 'img/icons/icon2-m.jpg'
		}
	},

	{
		name: {
			first: 'Trista',
			last: 'Pérez'
		},

		picture: {
			thumbnail: 'img/icons/icon2-f.jpg'
		}
	},

	{
		name: {
			first: 'Gwillor',
			last: 'Smith'
		},

		picture: {
			thumbnail: 'img/icons/icon3-f.jpg'
		}
	},

	{
		name: {
			first: 'Steph',
			last: 'Davidson'
		},

		picture: {
			thumbnail: 'img/icons/icon4-f.jpg'
		}
	},

	{
		name: {
			first: 'James',
			last: 'Singleton'
		},

		picture: {
			thumbnail: 'img/icons/icon3-m.jpg'
		}
	}
];